export const loginRouteName = "login";
export const resetPasswordRouteName = "password-reset";
export const feedbackTypes = {
	login: "login",
	address: "wallet_address_updated",
	video: "videos_viewed"
};
export const TRUSTPITOL_LINK = "https://de.trustpilot.com/evaluate/block-b.de";
